export const RESET_PASSWORD_MESSAGE =
  "Bonne nouvelle !\nUn email de réinitialisation vous a été envoyé par mail, jetez-y un coup d'oeil !\n(N'oubliez pas les spams)";
